import { takeLatest, put, all, call } from 'redux-saga/effects'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

import api from '~/services/api'

import {
  Types,
  updateReserves,
  updateActiveVoucher,
  updateVoucherRedeemed,
  updateNewConsumer
} from './actions'

var utc = require('dayjs/plugin/utc')
var localeData = require('dayjs/plugin/localeData')
var isBetween = require('dayjs/plugin/isBetween')

dayjs.extend(utc)
dayjs.extend(localeData)
dayjs.extend(isBetween)
dayjs.locale('pt-br')

export function * getReserves ({ payload }) {
  const { campaignId, storeId, redemptionDate } = payload

  if (!campaignId || !storeId) yield put(updateReserves({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/store/vouchers?storeId=${storeId}&redemptionDate=${redemptionDate}`

  try {
    const response = yield call(
      api.get,
      url
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        const initialDate = dayjs(response.data.data[0]?.initialDateRedeem).format('YYYY-MM-DD')
        const finalDate = dayjs(response.data.data[0]?.finalDateRedeem).format('YYYY-MM-DD')

        const reserves = response.data.data

        reserves[0].vouchers = reserves[0].vouchers.filter(voucher => dayjs(voucher.expirationDate).isBetween(initialDate, finalDate, 'date', []))

        yield put(updateReserves({ reserves }))
      } else {
        yield put(updateReserves({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateReserves({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateReserves({ error: error.message }))
  }
}

export function * searchVoucher ({ payload }) {
  const { campaignId, storeId, voucherCode, consumerCpf } = payload

  if (!campaignId || !storeId) yield put(updateActiveVoucher({ error: 'Ocorreu um erro ao processar a requisição' }))
  if (!voucherCode && !consumerCpf) yield put(updateActiveVoucher({ error: 'Verifique se CPF ou código do voucher estão corretos' }))

  const url = `/campaign/${campaignId}/store/prm/redeem/check`

  const params = voucherCode ? { voucherCode } : { consumerCpf }
  params.storeCode = parseInt(storeId)

  try {
    const response = yield call(
      api.post,
      url,
      params
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateActiveVoucher({ voucher: response.data.data[0] }))
      } else {
        if (response.data.data.length > 0) {
          yield put(updateActiveVoucher({ error: response?.data?.errors[0] || response.data.message, voucher: response.data.data[0] }))
        } else {
          yield put(updateActiveVoucher({ error: response?.data?.errors[0] || response.data.message }))
        }
      }
    } else {
      yield put(updateActiveVoucher({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateActiveVoucher({ error: error.message }))
  }
}

export function * setVoucherRedeemed ({ payload }) {
  const { campaignId, storeId, voucherCode, employeeCpf, employeeType, metadata } = payload

  if (!campaignId || !storeId || !voucherCode) yield put(updateVoucherRedeemed({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/store/voucher/${voucherCode}/prm/redeem`

  const params = {
    storeCode: parseInt(storeId),
    employeeType: employeeType || 'employee'
  }

  if (employeeCpf) {
    params.employeeCpf = employeeCpf
  }

  if (metadata) {
    params.metadata = metadata
  }

  try {
    const response = yield call(
      api.post,
      url,
      params
    )

    if (response.status === 200) {
      if (response.data.success) {
        yield put(updateVoucherRedeemed({ redeemed: true, data: response.data.data[0] }))
        yield put(updateNewConsumer({ newConsumer: {} }))
      } else {
        yield put(updateVoucherRedeemed({ error: response?.data?.errors.join(', ') || response.data.message }))
      }
    } else {
      yield put(updateVoucherRedeemed({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateVoucherRedeemed({ error: error.message }))
  }
}

export default all([
  takeLatest(Types.getReserves, getReserves),
  takeLatest(Types.searchVoucher, searchVoucher),
  takeLatest(Types.setVoucherRedeemed, setVoucherRedeemed)
])
